import { WbButton } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { useReleaseDetailPageContext } from './context/useReleaseDetailPageContext';
import { Deploy } from './types';

interface Props {
  deploy: Deploy;
}

export const LogFileButton: FC<Props> = ({ deploy }) => {
  const { setSelectedDeploy, setIsLogsDrawerOpen } =
    useReleaseDetailPageContext();

  return (
    <WbButton
      variant="text"
      label="Log File"
      onClick={() => {
        setSelectedDeploy(deploy);
        setIsLogsDrawerOpen(true);
      }}
    />
  );
};
